import { Component, Input, OnInit } from '@angular/core';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MethodsUtils } from '../../util/methods.utils';
import { NgStyle } from '@angular/common';

@Component({
  selector: 'app-progress-bar-data',
  standalone: true,
  imports: [
    MatProgressBarModule,
    NgStyle,
  ],
  templateUrl: './progress-bar-data.component.html',
  styleUrl: './progress-bar-data.component.css'
})
export class ProgressBarDataComponent implements OnInit {
  @Input() data = ""; // ex 12 : 00
  @Input() tempoFinalizar = 0;
  @Input() width = '160px';
  @Input() height = '24px';
  @Input() left = '50%';
  @Input() verificaFinalizada = false;
  @Input() font?: string;

  isFinalizada = false

  ngOnInit(): void {
    if(this.verificaFinalizada){
      this.verificarData()
    }
  }

  verificarData(){
    if (this.data && this.data == "00:00") {
      this.data = "Finalizada"
      this.isFinalizada = true
      this.tempoFinalizar = 100
    }
  }

  getCorPrazo(progresso: number): string{
    return !this.isFinalizada ? MethodsUtils.getCorPrazo(progresso) : '#000'
  }

  getCorLabel(progresso: number): string{
    if (progresso >= 75) {
      return '#FFF';
    }else{
      return !this.isFinalizada ? '#000' : '#FFF'
    }
  }
}
